"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("modules/app/services/datahub/constants");
const DatahubService_1 = __importDefault(require("modules/app/services/datahub/DatahubService"));
const helper_1 = require("modules/app/services/datahub/helper");
const datahubCommunityTypes_1 = require("./datahubCommunityTypes");
class DatahubCommunityService {
}
DatahubCommunityService.sendOpenPageEvent = (userId) => {
    DatahubService_1.default.sendEvent({
        action: constants_1.EVENT_ACTIONS.INTERACT,
        event: (0, helper_1.buildInteractionEventData)({
            category: datahubCommunityTypes_1.CommunityCategory.emptyStateOldClubCommunity,
            action: constants_1.EVENTS_INTERACTIONS.SHOW,
            label: datahubCommunityTypes_1.CommunityLabel.pageView,
            userId
        })
    });
};
DatahubCommunityService.sendAboutMoreEvent = (userId) => {
    DatahubService_1.default.sendEvent({
        action: constants_1.EVENT_ACTIONS.INTERACT,
        event: (0, helper_1.buildInteractionEventData)({
            category: datahubCommunityTypes_1.CommunityCategory.emptyStateOldClubCommunity,
            action: constants_1.EVENTS_INTERACTIONS.CLICK,
            label: datahubCommunityTypes_1.CommunityLabel.buttonKnowMore,
            userId
        })
    });
};
DatahubCommunityService.sendRedirectToNewClubEvent = (userId) => {
    DatahubService_1.default.sendEvent({
        action: constants_1.EVENT_ACTIONS.INTERACT,
        event: (0, helper_1.buildInteractionEventData)({
            category: datahubCommunityTypes_1.CommunityCategory.emptyStateOldClubCommunity,
            action: constants_1.EVENTS_INTERACTIONS.CLICK,
            label: datahubCommunityTypes_1.CommunityLabel.buttonAccessCommunity,
            userId
        })
    });
};
exports.default = DatahubCommunityService;
